import {MatchmakingMatchTypes} from '@colonist/game-base-types'

export enum MatchmakingPriority {
    Low,
    Medium,
    High,
}

export const rankedMatchmakingMatchTypes: Set<MatchmakingMatchTypes> = new Set([
    MatchmakingMatchTypes.RankedCitiesAndKnights4P,
    MatchmakingMatchTypes.RankedClassic4P,
    MatchmakingMatchTypes.RankedClassic56P,
    MatchmakingMatchTypes.RankedSeafarers4P,
    MatchmakingMatchTypes.RankedSeafarers56P,
    MatchmakingMatchTypes.RankedCitiesAndKnights56P,
    MatchmakingMatchTypes.RankedClassic1v1,
])

export const citiesAndKnightsMatchmakingMatchTypes: Set<MatchmakingMatchTypes> = new Set([
    MatchmakingMatchTypes.RankedCitiesAndKnights4P,
    MatchmakingMatchTypes.UnrankedCitiesAndKnights4P,
    MatchmakingMatchTypes.RankedCitiesAndKnights56P,
    MatchmakingMatchTypes.UnrankedCitiesAndKnights56P,
])

export type ActiveMatchmakingMatchTypes =
    MatchmakingMatchTypes.UnrankedClassic4P |
    MatchmakingMatchTypes.RankedClassic4P |
    MatchmakingMatchTypes.UnrankedClassic1v1 |
    MatchmakingMatchTypes.RankedClassic1v1 |
    MatchmakingMatchTypes.RankedCitiesAndKnights4P |
    MatchmakingMatchTypes.UnrankedShuffle

export enum MatchmakingCriteriaTypes {
    None,
    Karma,
    ELO,
    SameIP,
}

export enum MatchmakingCancelReason {
    ClickedCancel,
    FailedToWatchVideoAd,
}
